module.exports = __webpack_public_path__ + "static/media/icon_realise_big_bleu.82304a60.svg";